/**
 *
 * @param {{title, children:Readonly<React.ReactNode>, right:boolean }} param0
 * @returns
 */
export const RelativeModal = ({ title, isActive, handleToggle, children, right }) => {
  return (
    <div className={'relative z-30'}>
      <div onClick={handleToggle} className={'btn btn-md btn-solid-black w-fit'}>
        {title}
      </div>
      <div className={`absolute top-14 ${right ? 'right-0' : ''} ${!isActive ? 'hidden' : ''}`}>{children}</div>
    </div>
  )
}

export const RelativeWishlistModal = ({ title, children }) => {
  return <div> </div>
}
